import React, { useCallback, useEffect, useRef, useState } from "react";
import { NewsFeed } from "../../config/imagesLink";
import axios, { buildVideoIndexerManifestUrl } from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import ReactQuill from "react-quill";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import AddAPhotoSharpIcon from "@mui/icons-material/AddAPhotoSharp";
import PostComponent from "./PostComponent";
import Select from "react-select";
import moment from "moment";
import { Link } from "react-router-dom";
import SinglePostInteraction from "./SinglePostInteraction";
import PublicSharpIcon from "@mui/icons-material/PublicSharp";
import GroupSharpIcon from "@mui/icons-material/GroupSharp";
import LockSharpIcon from "@mui/icons-material/LockSharp";
import TuneSharpIcon from "@mui/icons-material/TuneSharp";
import {customStyles, wljSelectPortalProps} from "../../selectStyles";
import Hls from "hls.js";
import Plyr from "plyr";
import "plyr/dist/plyr.css";
import { useTranslation } from "react-i18next";
import formatPostContent from "../../utility/formatPostContent";
import { normalizeNewsFeedPost } from "../../utility/newsFeedPost";
import useEscapeKeyDown from "../../hooks/useEscapeKeyDown";
import { ImageWithLoader } from "@skeleton";
import { Portal } from "../../components/Portal";

const PostUpdate = ({
  // showModal,
  openModal,
  closeModal,
  showModal,
  item,
  postList,
  PostOriginType,
  postOriginId,
  postId,
  setShowModal,
  setPostList,
  // restrictedViewerToken,
  AllPostList,
}) => {
  console.log("ItemUPpdte===>", item)
  const [postDataItem, setPostDataItem] = useState("");
  const [fullContentData, setFullContentData] = useState(null); // Store full content from readMore API
  const profilPic = localStorage.getItem("profilPic");
  const [postContent, setPostContent] = useState("");
  console.log("itemitem", item, postId);
  const restrictedViewerToken = localStorage.getItem("restrictedViewerToken");
  const language = localStorage.getItem("Lang");
  const { t } = useTranslation();

  const GetPostData = async () => {
    try { 
      const resData = await axios.get(`/Posts/GetPostInfo?DeviceType=Web&PostId=${postId}&RestrictedViewerToken=${restrictedViewerToken}&langKey=${language}`);
      const response = resData?.data?.responseData;
      // console.log("Response qwerty====>", response)
      const rawContent = response?.postInfo?.postInfo?.readMore ;
      const dynamicValues = response?.postInfo?.postInfo?.dynamicValues || [];
      console.log("postDataItem", rawContent);
 
      setPostDataItem(response);
       if(response?.postInfo?.postInfo.readMore === true){
        readMore(response?.postInfo?.postInfo.postId);
      }
      // setPostDynamicValues(dynamicValues); // Track original values
      setUserSelectedImage(response?.postInfo?.postInfo?.mediaFilesList || []);
    } catch (error) {
      console.log(error);
    }
  };

  console.log("postDataItem", postDataItem);
  const readMore = async (id) => {
    try {
      const res = await axios.get(
        `/Posts/GetPostMainContent?DeviceType=Web&PostId=${id}&langKey=${language}`
      );
      console.log("momredata", res);
      
      // Store the full content data to be processed later by useEffect
      if (res?.data?.responseData) {
        setFullContentData(res.data.responseData);
      }
       
    } catch (error) {
      console.log(error);
    }
  };
console.log("fullContentData", fullContentData);
  useEffect(() => {
    GetPostData();
     
  }, []);
  //  useEffect(()=> {
  //     if(postDataItem?.postInfo?.postInfo.readMore === true){
  //       readMore(postDataItem?.postInfo?.postInfo.postId);
  //     }
  //   },[])

  const [removedImageIds, setRemovedImageIds] = useState([]); // To track removed image IDs
  const sessionId = localStorage.getItem("sessionId");
  const userUid = localStorage.getItem("userUid");
  const inputFileRef = useRef(null);
  let pri = item?.postInfo?.privacyType;
  console.log("PrivacyType===>", pri)
  const [postData, setPostData] = useState();
  const [privacyType, setPrivacyType] = useState(pri);
  const [imageNames, setImageNames] = useState("");
  const [selectedImages, setSelectedImages] = useState([]);
  // const [PostContents, setPostContents] = useState(postDataItem);
  const [images, setImages] = useState([]);
  const [userSelectedImage, setUserSelectedImage] = useState([]);
  const [showPost, setShowPost] = useState(false);
  const [display, setDisplay] = useState(false);
  const [postID, setPostID] = useState("");

  console.log("PostContents", postContent);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(true);

  const [showsuccessToast, setShowSuceessToast] = useState(false)

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [isloading, setIsloading] = useState(false);
  const guestModeData = localStorage.getItem("guestMode");

  const editorRef = useRef(null);
  const [postInputValue, setPostInputValue] = useState("");
  const [postDynamicValues, setPostDynamicValues] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [mentionType, setMentionType] = useState("");
  const [SearchText, setSearchText] = useState("")
  const [query, setQuery] = useState("");
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [cursorPosition, setCursorPosition] = useState(0);

    const [selectedIndex, setSelectedIndex] = useState(0);
    
    const suggestionListRef = useRef(null);
      const itemRefs = useRef([]);

  // const determinePostCategory = (postContent, newImages, existingImages) => {
  //   const containsVideo = (names) => {
  //     const videoExtensions = [
  //       ".mp4",
  //       ".webm",
  //       ".avi",
  //       ".mov",
  //       ".mkv",
  //       ".flv",
  //       ".wmv",
  //     ];
  //     return names.some((name) =>
  //       videoExtensions.includes(
  //         name?.slice(name.lastIndexOf(".")).toLowerCase()
  //       )
  //     );
  //   };

  //   const hasPostContent = postContent !== null && postContent.trim() !== "";
  //   const allImages = [...newImages, ...existingImages];
  //   const imageNames = allImages.map((image) => image.name || image.mediaName);

  //   const hasImages = imageNames.length > 0 && !containsVideo(imageNames);
  //   const hasVideos = imageNames.length > 0 && containsVideo(imageNames);

  //   if (
  //     (hasPostContent && hasImages) ||
  //     (hasPostContent && hasVideos) ||
  //     (hasImages && hasVideos)
  //   ) {
  //     return "UserStory";
  //   } else if (hasPostContent) {
  //     return "Text";
  //   } else if (hasImages) {
  //     return "Image";
  //   } else if (hasVideos) {
  //     return "Video";
  //   } else {
  //     return "UserStory";
  //   }
  // };
  console.log("handleSubmit00000000000000", item);
  const determinePostCategory = (postContent, newMediaFiles, existingMediaFiles) => {
    const videoExtensions = [
      ".mp4", ".webm", ".avi", ".mov", ".mkv", ".flv", ".wmv"
    ];

    const isVideo = (name) =>
      videoExtensions.includes(name?.slice(name.lastIndexOf(".")).toLowerCase());

    const hasPostContent = postContent?.trim() !== "";

    const allMedia = [...newMediaFiles, ...existingMediaFiles];

    const hasVideos = allMedia.some((file) =>
      isVideo(file.name || file.mediaName)
    );

    const hasImages = allMedia.some((file) =>
      !isVideo(file.name || file.mediaName)
    );

    // if (hasPostContent && hasVideos && !hasImages) return "TextWithVideo";
    // if (hasPostContent && hasImages && !hasVideos) return "UserStory";
    // if (hasVideos && hasImages) return "UserStory";
    // if (hasPostContent && hasVideos) return "TextWithVideo";
    // if (hasPostContent && !hasImages && !hasVideos) return "Text";
    // if (!hasPostContent && hasImages && !hasVideos) return "Image";
    // if (!hasPostContent && hasVideos && !hasImages) return "Video";
    // if (hasPostContent && !hasVideos && hasImages) return "TextWithImage";
    if (hasPostContent && hasVideos && !hasImages) return "TextWithVideo";
    if (!hasPostContent && hasVideos && !hasImages) return "Video";
    if (hasPostContent && hasImages && !hasVideos) return "TextWithImage";
    if (!hasPostContent && hasImages && !hasVideos) return "Image";
    if (hasVideos && hasImages && hasPostContent) return "TextWithVideo"; // ✅ treat as TextWithVideo not UserStory
    if (hasVideos && hasImages && !hasPostContent) return "UserStory"; // purely media mix
    if (hasPostContent && !hasImages && !hasVideos) return "Text";

    return "UserStory"; // default fallback
  };




  const handleSubmit = async () => {
    setIsloading(true);

    try {
      //  const isVideo = item.cntntTypCategory === "TextWithVideo";
      //  const isVideo = userSelectedImage?.some(item => item.mediaType === "Video");
      // const postCategory = determinePostCategory(postContent);
      if (item.cntntTypCategory === "TextWithVideo" || item.cntntTypCategory === "Video") {

        const VideopostCategory = determinePostCategory(
          postContent,
          images, // new media files
          userSelectedImage
        );

        const videoBody = {
          deviceType: "Web",
          sessionId: sessionId,
          postId: postId,
          privacyType: privacyType,
          postCategory: VideopostCategory,
          postContent: postInputValue || postContent || "",
          dynamicValues: prepareDynamicValuesForPayload(postDynamicValues),
                langKey: language === "en" ? "" : language,

        };

        const response = await axios.post("Posts/UpdateVideoPost", videoBody,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        // console.log("Video Post Updated:", response.data);
        setToastMessage(response.data.message);
        setShowSuceessToast(true);

      } else {
        const formData = new FormData();
        formData.append("PostId", postId);
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append(
          "PrivacyType",
          privacyType === null ? "Public" : privacyType
        );
        formData.append("PostOriginType", PostOriginType);
        // const newImages = images.map((image) => image.name);
        // const existingImages = userSelectedImage.map((image) => image.mediaName);
        const newImages = (images || []).map((image) => image.name);
        // const existingImages = (userSelectedImage || []).map((image) => image.mediaName);
        const existingImages = (userSelectedImage || [])
          .filter(img => !removedImageIds.includes(img.pstMid))
          .map(image => image.mediaName);
        const postCategory = determinePostCategory(
          postContent,
          newImages,
          existingImages
        );

        formData.append("PostCategory", postCategory);
        formData.append("PostContent", postInputValue || postContent || "");
        formData.append(
          "DynamicValues",
          JSON.stringify(prepareDynamicValuesForPayload(postDynamicValues))
        );
        removedImageIds.forEach((id) => {
          formData.append("OldFilesToDelete", id);
        });
        images.forEach((file) => {
          formData.append(`FilesToUpload`, file.file);
        });

        formData.append("PostOriginID", postOriginId);
        formData.append("langKey", language === "en" ? "" : language);

        const res = await axios.post("/Posts/UpdatePost", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        // console.log("postUpdate0000000", res);
        setWarningToastMessage(res.data?.message || "Not Found");
        setShowWarningToast(true);

        if (res.status === 200) {
          // console.log("postUpdate0000000", res.data.message, showsuccessToast);

          setToastMessage(res.data.message);
          setShowSuceessToast(true);


        }
      }
      const newPostId = postId;
      const postDetailsResponse = await axios.get(
        `/Posts/GetPostInfo?DeviceType=Web&PostId=${newPostId}&RestrictedViewerToken=${restrictedViewerToken}&langKey=${language}`
      );
      const updatedPost = postDetailsResponse?.data?.responseData?.postInfo;

      setPostList((prev) =>
        prev.map((post) =>
          post?.postInfo?.postId === updatedPost?.postInfo?.postId ? updatedPost : post
        )
      );
      AllPostList(1);
      setTimeout(() => {
        setShowModal(!showModal)
        // closeModal();
      }, 1000);
      // setPostContent("");

      setIsloading(false);
    } catch (e) {
      console.log("Error in handleSubmit:", e);

      const status = e?.response?.status;
      const data = e?.response?.data;

      if (status === 404) {
        setWarningToastMessage(data?.message || "Not Found");
        setShowWarningToast(true);
      } else if (status === 400 && data?.errors) {
        const allErrors = Object.values(data.errors).flat();
        const errorMessage = allErrors.length > 0 ? allErrors[0] : data?.title || "Validation error";
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
      } else {
        setErrorToastMessage(e?.message || "Something went wrong.");
        setShowErrorToast(true);
      }

      setIsloading(false);
    }

  };

  const imageSelect = (event) => {
    console.log("image selected", event);
    const selectedFiles = event.target.files;
    console.log("selectedFiles", selectedFiles);
    const newImages = [];

    for (let i = 0; i < selectedFiles.length; i++) {
      const imageName = selectedFiles[i].name;
      if (!checkDuplicate(imageName)) {
        const imageUrl = URL.createObjectURL(selectedFiles[i]);
        newImages.push({
          name: imageName,
          url: imageUrl,
          file: selectedFiles[i],
        });
      } else {
        alert(`${imageName} is already added to the list`);
      }
    }

    setImages((prevImages) => [...prevImages, ...newImages]);
    event.target.value = null; // Reset file input
    console.log("image selected1", images);
  };

  const checkDuplicate = (name) => {
    return images.some((image) => image.name === name);
  };


  console.log("image index", userSelectedImage);
  const userImages = (index) => {
    const removedImage = userSelectedImage[index];
    setRemovedImageIds((prevIds) => [...prevIds, removedImage.pstMid]); // Add removed image ID to the state
    setUserSelectedImage((prevImages) =>
      prevImages.filter((_, i) => i !== index)
    );
  };

  useEffect(() => {
    setUserSelectedImage(postDataItem?.postInfo?.postInfo?.mediaFilesList); // Initialize the state with the media files list
    console.log("useEffect is run");
  }, [postDataItem?.postInfo?.postInfo?.mediaFilesList]);

    
 

  const handleShowPost = () => {
    setShowPost(true);
  };

  const handleClosePost = () => {
    setShowPost(false);
  };
  const mediaFiles = postDataItem?.postInfo?.postInfo?.mediaFilesList?.map((item) => item?.pstMid);

  const handleImageChange = (event) => {
    const files = Array.from(event.target.files);
    const fileNames = files.map((file) => file.name);
    setImageNames(fileNames.join(", "));
    const imageUrls = files.map((file) => URL.createObjectURL(file));
    setSelectedImages((prevImages) => [...prevImages, ...imageUrls]);
  };

  const handleRemoveImage = (index) => {
    setSelectedImages((prevImages) => prevImages.filter((_, i) => i !== index));
    setImageNames((prevNames) => {
      const namesArray = prevNames.split(", ");
      namesArray.splice(index, 1);
      return namesArray.join(", ");
    });
  };
  const privacy = [
    { value: "Public", label: t("Newsfeed.Public") , icon: <PublicSharpIcon /> },
    { value: "Friends", label: t("Newsfeed.Friends") , icon: <GroupSharpIcon /> },
    { value: "OnlyMe", label: t("Newsfeed.OnlyMe"), icon: <LockSharpIcon /> },
    { value: "Custom", label: t("Newsfeed.Custom") , icon: <TuneSharpIcon /> },
    // { value: "Public", label: "Public", icon: <PublicSharpIcon /> },
    // { value: "Friends", label: "Friends", icon: <GroupSharpIcon /> },
    // { value: "OnlyMe", label: "OnlyMe", icon: <LockSharpIcon /> },
    // { value: "Custom", label: "Custom", icon: <TuneSharpIcon /> },
  ];
  const renderImages = () => {
    return images.map((image, index) => (
      <div
        key={index}
        className="image_container d-flex justify-content-center position-relative"
      >
        <img src={image.url} alt={image.name} />
        <span className="position-absolute" onClick={() => deleteImage(index)}>
          &times;
        </span>
      </div>
    ));
  };

  // const deleteImage = (index) => {
  //   console.log("ddddddddddddddd");

  //   const updatedImages = [...images];
  //   updatedImages.splice(index, 1);
  //   setImages(updatedImages);
  // };

  const deleteImage = (indexToRemove) => {
    console.log("ddddddddddddddd");
    const updatedList = userSelectedImage.filter((_, idx) => idx !== indexToRemove);
    setUserSelectedImage(updatedList);
  };



  const Privacy = [
    { value: "Public", label: "Public" },
    { value: "Friends", label: "Friends" },
    { value: "OnlyMe", label: "OnlyMe" },
    { value: "Custom", label: "Custom" },
  ];

  const removeImage = (index) => {
    console.log("hiiii");

    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  const handlePaste = (e) => {
    const isCtrlV = e.ctrlKey && e.key === "v"; // Check if Ctrl+V was pressed

    if (isCtrlV) {
      e.preventDefault(); // Prevent the default paste action
      alert("Please use Ctrl + Shift + V to paste."); // Show alert
    }
  };

  //Handle Shared Post Update
  const [postContentMap, setPostContentMap] = useState({});
  const [sharedPostContent, setSharedPostContent] = useState("");

  

  const sharedPostFormattedContent1 = formatPostContent(
    item?.postInfo?.sharedPost?.postContent,
    item?.postInfo?.sharedPost?.dynamicValues
  );

  const normalizeDynamicValues = (dynamicValues = []) => {
    return (dynamicValues || []).map((dv, idx) => {
      if (!dv) return null;
      const {
        type,
        dVno,
        // possible incoming names:
        entity,
        entityID,
        entityId,
        userUid,
        displayName,
        display,
        entityName,
        hashTag,
      } = dv;

      // Determine the type first
      const resolvedType = type || (hashTag ? "Hashtag" : "UserMention");

      // Resolve the display name
      const resolvedDisplayName = displayName ?? display ?? entityName ?? hashTag ?? "";

      // Resolve the entity (ID for User/Company, Text/ID for Hashtag)
      let resolvedEntity = entity ?? entityID ?? entityId ?? userUid ?? hashTag ?? resolvedDisplayName;

      // 🚨 FIX: If it's a Hashtag, ensure the entity is the display name (text)
      // This forces the entity back to the human-readable text, overriding any server-side ID
      if (resolvedType === "Hashtag") {
        resolvedEntity = resolvedDisplayName;
      }

      return {
        type: resolvedType,
        dVno: dVno ?? idx + 1,
        entity: resolvedEntity,
        displayName: resolvedDisplayName,
      };

    }).filter(Boolean);
  };


  // const replaceDynamicValues = (content, dynamicValues) => {
  //   if (!content || !dynamicValues) return content;

  //   dynamicValues.forEach((item) => {
  //     const placeholder = `{${item.dVno}}`;
  //     const displayName = item.displayName ?? item.display ?? "";
  //     const entityId = item.entity ?? item.entityID ?? "";
  //     const replacement =
  //       item.type === "UserMention"
  //         ? `<a href="/user/${entityId}" class="user-mention">@${displayName}</a>`
  //         : item.type === "Hashtag"
  //           ? `<a href="/hashtag/${displayName}" class="hashtag">#${displayName}</a>`
  //           : item.type === "CompanyMention"
  //             ? `<a href="/Company/${entityId}" class="hashtag">@${displayName}</a>`
  //             : item.displayName;

  //     content = content.replaceAll(placeholder, replacement);
  //   });

  //   return content;
  // };
  const replaceDynamicValues = (content, dynamicValues = []) => {
    console.log("Replce value===>", dynamicValues)
    if (!content || !dynamicValues) return content;
    const safeDynamicValues = Array.isArray(dynamicValues) ? dynamicValues : [];
    let result = content;
    safeDynamicValues.forEach((item) => {
      console.log("Item===>", item)
      const placeholder = `{${item.dVno}}`;
      const displayName = item.displayName ?? item.display ?? "";
      const entityId = item.entity ?? item.entityID ?? "";
      let replacement = "";

      if (item.type === "UserMention") {
        replacement = `@${displayName}`;
      } else if (item.type === "CompanyMention") {
        replacement = `@${displayName}`;
      } else if (item.type === "Hashtag") {
        replacement = `#${displayName}`;
      }

      result = result.replaceAll(placeholder, replacement);
    });

    return result;
  };
  
  // Process expanded content similar to PostComponent
  const processExpandedContent = (expandedContent, fallbackDynamicValues = []) => {
    let resolvedContent = expandedContent;
    let resolvedDynamicValues = fallbackDynamicValues;

    if (expandedContent && typeof expandedContent === "object") {
      resolvedContent =
        expandedContent?.postContent ||
        expandedContent?.mainContent ||
        expandedContent?.content ||
        expandedContent?.postMainContent ||
        "";

      if (Array.isArray(expandedContent?.dynamicValues) && expandedContent.dynamicValues.length) {
        resolvedDynamicValues = expandedContent.dynamicValues;
      }
    }

    const withDynamicValues = replaceDynamicValues(
      resolvedContent || "",
      resolvedDynamicValues || []
    );

    const cleanedContent = withDynamicValues.replace(/\{\d+\}/g, "");

    return {
      content: cleanedContent,
      dynamicValues: resolvedDynamicValues
    };
  };

  // Process full content when readMore API returns data
  useEffect(() => {
    if (fullContentData) {
      console.log("Processing full content from readMore API:", fullContentData);
      
      // Process the expanded content like PostComponent does
      const { content: processedContent, dynamicValues: processedDynamicValues } = 
        processExpandedContent(fullContentData, item?.postInfo?.dynamicValues || []);
      
      // Normalize the dynamic values
      const normalizedRaw = normalizeDynamicValues(processedDynamicValues);
      const normalized = Array.isArray(normalizedRaw) ? normalizedRaw : [];
      
      // Convert mentions to links for display
      const linkifiedContent = convertMentionsToLinks(processedContent, normalized);
      
      console.log("Setting post content to:", linkifiedContent);
      
      // Update all necessary states
      setSharedPostContent(linkifiedContent);
      setPostContent(linkifiedContent);
      setPostInputValue(processedContent);
      setPostDynamicValues(normalized);
    }
  }, [fullContentData]);



  // const handleChange = (content, delta, source, editor) => {
  //   const value = editor.getText(); // plain text, better than content HTML
  //   if (source !== "user") {
  //     setPostContent(content);
  //     return;
  //   }
  //   const caret = editor.getSelection()?.index || 0;

  //   setSharedPostContent(content);
  //   setPostContent(content);
  //   setCursorPosition(caret);
  //   detectTrigger(value, caret);

  //   // Filter out dynamic values no longer in content
  //   const safeDynamicValues = Array.isArray(postDynamicValues)
  // ? postDynamicValues
  // : [];
  
  //   const updatedDynamicValues = safeDynamicValues?.filter(
  //     ({ type, displayName, display }) => {
  //       const prefix = type === "UserMention" || type === "CompanyMention" ? "@" : "#";
  //       return value?.includes(`${prefix}${displayName || display}`);
  //     }
  //   );

  //   // Reassign dVno after filtering to keep {1}, {2}, ... in correct order
  //   const reassignedDynamicValues = updatedDynamicValues?.map((item, index) => ({
  //     ...item,
  //     dVno: index + 1,
  //    }));

  //   setPostDynamicValues(reassignedDynamicValues);

  //   // Recompute postInputValue
  //   const quillInstance = editorRef.current?.getEditor?.();
  //   const htmlContent = quillInstance?.root?.innerHTML || "";

  //   const updatedPostInputValue = updatePostInputValueWithDynamicValues(
  //     htmlContent,
  //     reassignedDynamicValues
  //   );

  //   setPostInputValue(updatedPostInputValue);
  // };

  const handleChange = (content, delta, source, editor) => {
  if (!editor) return;

  const value = editor.getText();
  const caret = editor.getSelection()?.index || 0;

  if (source !== "user") {
    setPostContent(content);
    return;
  }

  setSharedPostContent(content);
  setPostContent(content);
  setCursorPosition(caret);

  detectTrigger(value, caret);

  const safeDynamicValues = Array.isArray(postDynamicValues)
    ? postDynamicValues
    : [];

  const updatedDynamicValues = safeDynamicValues.filter(
    ({ type, displayName, display }) => {
      const prefix =
        type === "UserMention" || type === "CompanyMention"
          ? "@"
          : "#";

      const name = displayName || display;
      return value.includes(`${prefix}${name}`);
    }
  );

  const reassignedDynamicValues = updatedDynamicValues.map(
    (item, index) => ({
      ...item,
      dVno: index + 1,
    })
  );

  setPostDynamicValues(reassignedDynamicValues);

  // 🔥 SAFE HTML ACCESS
  const quillInstance = editorRef.current?.getEditor?.();
  const htmlContent = quillInstance?.root?.innerHTML || "";

  const updatedPostInputValue =
    updatePostInputValueWithDynamicValues(
      htmlContent,
      reassignedDynamicValues
    );

  setPostInputValue(updatedPostInputValue);
};


  // useEffect(() => {
  //   if (item?.postInfo?.postContent) {
  //     const rawHtlm = item?.postInfo?.postContent;
  //     const normalizedRaw = normalizeDynamicValues(
  //       item.postInfo.dynamicValues || []
  //     );
  //     const normalized = Array.isArray(normalizedRaw)
  //         ? normalizedRaw
  //         : [];
  //     // const normalized = normalizeDynamicValues(item.postInfo.dynamicValues || []);
  //     // const formatted = linkifyContent(
  //     //   addTargetBlankToAnchors(
  //     //     replaceDynamicValues(item.postInfo.postContent, item.postInfo.dynamicValues)
  //     //   )
  //     // );
  //     const formatted = replaceDynamicValues(rawHtlm, normalized)

  //     setSharedPostContent(formatted);
  //     setPostContent(formatted);
  //     // const initialPostInput = updatePostInputValueWithDynamicValues(formatted, normalized);
  //     setPostInputValue(formatted);
  //     setPostDynamicValues(normalized);
  //   }
  // }, [item]);

  const convertMentionsToLinks = (content, dynamicValues) => {
  let modified = content;

  ensureArray(dynamicValues).forEach(
    ({ type, displayName, display, entity }) => {
      const prefix =
        type === "UserMention" || type === "CompanyMention"
          ? "@"
          : "#";

      const name = displayName || display;
      const fullText = `${prefix}${name}`;

      const link =
        type === "UserMention" || type === "CompanyMention"
          ? `/profile/${entity}`
          : `/hashtag/${name}`;

      const regex = new RegExp(
        escapeRegex(fullText) + "(?![^<]*>)",
        "g"
      );

      modified = modified.replace(
        regex,
        `<a href="${link}" target="_blank" class="mention-link">${fullText}</a>`
      );
    }
  );

  return modified;
};


  useEffect(() => {
  if (item?.postInfo?.postContent) {
    const rawHtml = item.postInfo.postContent;

    const normalizedRaw = normalizeDynamicValues(
      item.postInfo.dynamicValues || []
    );

    const normalized = Array.isArray(normalizedRaw)
      ? normalizedRaw
      : [];

    const replacedContent = replaceDynamicValues(
      rawHtml,
      normalized
    );

    const linkifiedContent = convertMentionsToLinks(
      replacedContent,
      normalized
    );

    setSharedPostContent(linkifiedContent);
    setPostContent(linkifiedContent);
    setPostInputValue(rawHtml);
    setPostDynamicValues(normalized);
  }
}, [item]);


  const updatePostInputValueWithDynamicValues = (rawContent, dynamicValues) => {
    let modifiedText = rawContent;

    dynamicValues?.forEach(({ type, dVno, displayName, display }) => {
      const prefix = type === "UserMention" || type === "CompanyMention" ? "@" : "#";
      const name = displayName || display;
      const fullMention = `${prefix}${name}`;
      // const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
      const regex = new RegExp(
        `${escapeRegex(fullMention)}(?=\\s|&nbsp;|<|$)`,
        "gi"
      );
      modifiedText = modifiedText?.replace(regex, `{${dVno}}`);
      console.log("Replacing:", fullMention, "=>", `{${dVno}}`);
    });

    return modifiedText?.trim();
  };

  // Detect @ or #
  const detectTrigger = (value, caret) => {
    const textBeforeCursor = value?.slice(0, caret);
    const match = textBeforeCursor.match(/([@#])(\w*)$/);
    if (match) {
      const trigger = match[1];
      const q = match[2];
      setMentionType(trigger === "@" ? "UserMention" : "Hashtag");
      setQuery(q);
      fetchSuggestions(q, trigger);
      setSearchText(q)
    } else {
      //setShowSuggestions(false);
      setSearchText('')
    }
  };

  const fetchSuggestions = async (searchText, triggerChar) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
            langKey: language === "en" ? "" : language,

    };

    try {
      if (triggerChar === "@") {
        const res = await axios.post(
          `General/MentionTagDDL?Search=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      } else if (triggerChar === "#") {
        const res = await axios.post(
          `General/HashtagDDL?SearchHashtag=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      }
    } catch (err) {
      console.error(err);
      if (triggerChar === "#" && searchText) {
        setShowSuggestions(true);
      } else {
        setShowSuggestions(false);
      }
    }
  };

  // const insertMention = (suggestion, userUid, entityType) => {
  //   const quill = editorRef.current?.getEditor?.();
  //   if (!quill) return;

  //   const cursorPosition = quill.getSelection()?.index || 0;
  //   const textBeforeCursor = quill.getText(0, cursorPosition);
  //   const match = textBeforeCursor.match(/[@#]\w*$/);
  //   if (!match) return;

  //   const startIndex = cursorPosition - match[0].length;
  //   const mentionPrefix = mentionType === "UserMention" || entityType === "CompanyMention" ? "@" : "#";
  //   const displayName = suggestion;
  //   const mentionText = `${mentionPrefix}${displayName || display} `;

  //   // Replace partial mention with full one
  //   quill.deleteText(startIndex, match[0].length);
  //   quill.insertText(startIndex, mentionText);
  //   quill.setSelection(startIndex + mentionText.length);

  //   console.log("Mention Inserted:", mentionText);

  //   // Update dynamic values
  //   const safePostDynamicValues = Array.isArray(postDynamicValues)
  //     ? postDynamicValues
  //     : [];

  //   const dVno = safePostDynamicValues.length + 1;

  //   // const updatedPostDynamicValues = [
  //   //   ...safePostDynamicValues,
  //   //   {
  //   //     type: mentionType,
  //   //     dVno,
  //   //     entity: mentionType === "UserMention" ? userUid : suggestion,
  //   //     display: displayName,
  //   //   },
  //   // ];
  //   let newDynamicValue = null;
  //   if (mentionType === "UserMention" || entityType === "CompanyMention") {
  //     newDynamicValue = {
  //       type: entityType || mentionType,
  //       dVno,
  //       entity: userUid, // userUid or companyUid
  //       display: displayName,
  //     };
  //   } else if (mentionType === "Hashtag") {
  //     newDynamicValue = {
  //       type: "Hashtag",
  //       dVno,
  //       entity:suggestion || displayName, // naya ya existing hashtag text
  //       display: displayName,
  //     };
  //   }
  //   const updatedPostDynamicValues = [...safePostDynamicValues, newDynamicValue]

  //   setPostDynamicValues(updatedPostDynamicValues);
const quillInstance = editorRef.current?.getEditor?.();
const editorHtml = quillInstance?.root?.innerHTML || "";

  //   const editorHtml = quill.root.innerHTML;
  //   const updatedInputValue = updatePostInputValueWithDynamicValues(
  //     editorHtml,
  //     updatedPostDynamicValues
  //   );
  //   setPostInputValue(updatedInputValue);
  //   setShowSuggestions(false);
  //   setSearchText('')
  // };

  // Helper: Escape regex special characters
const ensureArray = (val) => (Array.isArray(val) ? val : []);

// const insertMention = (suggestion, userUid, entityType) => {
//   const quill = editorRef.current?.getEditor?.();
//   if (!quill) return;

//   const cursorPosition = quill.getSelection()?.index || 0;
//   const textBeforeCursor = quill.getText(0, cursorPosition);
//   const match = textBeforeCursor.match(/[@#]\w*$/);
//   if (!match) return;

//   const startIndex = cursorPosition - match[0].length;

//   const isUser =
//     mentionType === "UserMention" ||
//     entityType === "CompanyMention";

//   const prefix = isUser ? "@" : "#";
//   const displayName = suggestion;

//   const mentionText = `${prefix}${displayName}`;

//   quill.deleteText(startIndex, match[0].length);

//   // 🔥 Insert formatted link
//   quill.insertText(startIndex, mentionText, {
//     link: isUser
//       ? `/profile/${userUid}`
//       : `/hashtag/${displayName}`,
//     color: "#0A66C2",
//   });

//   quill.insertText(startIndex + mentionText.length, " ");
//   quill.setSelection(startIndex + mentionText.length + 1);

//   // Update dynamic values safely
//   const safeDynamicValues = ensureArray(postDynamicValues);

//   const dVno = safeDynamicValues.length + 1;

//   const newDynamicValue = {
//     type: isUser ? entityType || mentionType : "Hashtag",
//     dVno,
//     entity: isUser ? userUid : displayName,
//     display: displayName,
//   };

//   const updatedValues = [...safeDynamicValues, newDynamicValue];

//   setPostDynamicValues(updatedValues);

//   const editorHtml = quill.root?.innerHTML;

//   const updatedInputValue =
//     updatePostInputValueWithDynamicValues(
//       editorHtml,
//       updatedValues
//     );

//   setPostInputValue(updatedInputValue);

//   setShowSuggestions(false);
// };

const insertMention = (suggestion, userUid, entityType) => {
  const quill = editorRef.current?.getEditor?.();
  if (!quill) return;

  const cursorPosition = quill.getSelection()?.index || 0;
  const textBeforeCursor = quill.getText(0, cursorPosition);
  const match = textBeforeCursor.match(/[@#]\w*$/);
  if (!match) return;

  const startIndex = cursorPosition - match[0].length;

  const isUser =
    mentionType === "UserMention" ||
    entityType === "CompanyMention";

  const prefix = isUser ? "@" : "#";
  const displayName = suggestion?.trim();

  if (!displayName) return;

  const mentionText = `${prefix}${displayName}`;

  // Remove partial typed text
  quill.deleteText(startIndex, match[0].length);

  quill.insertText(startIndex, mentionText, "user");

  quill.insertText(startIndex + mentionText.length, " ");
  quill.setSelection(startIndex + mentionText.length + 1);

  // -------- Dynamic Value --------
  const safeDynamicValues = Array.isArray(postDynamicValues)
    ? postDynamicValues
    : [];

  const dVno = safeDynamicValues.length + 1;

  const newDynamicValue = {
    type: isUser ? entityType || "UserMention" : "Hashtag",
    dVno,
    entity: isUser ? userUid : displayName,
    display: displayName,
  };

  const updatedValues = [...safeDynamicValues, newDynamicValue];

  setPostDynamicValues(updatedValues);

  // Safe HTML access
  const quillInstance = editorRef.current?.getEditor?.();
  const editorHtml = quillInstance?.root?.innerHTML || "";

  const updatedInputValue =
    updatePostInputValueWithDynamicValues(
      editorHtml,
      updatedValues
    );

  setPostInputValue(updatedInputValue);

  setShowSuggestions(false);
  setSelectedIndex(0);
};

const escapeRegex = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

const handleKeyDown1 = (e) => {
    if (showSuggestions) {
      const totalItems = mentionType === "Hashtag" ? suggestions.length + 1 : suggestions.length;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedIndex((prev) => (prev + 1) % totalItems);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedIndex((prev) => (prev - 1 + totalItems) % totalItems);
      } else if (e.key === "Enter") {
        e.preventDefault();

        if (mentionType === "Hashtag" && selectedIndex === 0) {
          insertMention(SearchText, null);
        } else {
          const itemIndex = mentionType === "Hashtag" ? selectedIndex - 1 : selectedIndex;
          const selectedItem = suggestions[itemIndex];
          if (selectedItem) {
            insertMention(
              (mentionType === "UserMention" || mentionType === "CompanyMention") ? selectedItem?.entityName : selectedItem?.hashTag,
              (mentionType === "UserMention" || mentionType === "CompanyMention") ? selectedItem?.userUid : null,
              selectedItem?.entityType,
            );
          }
        }

        setShowSuggestions(false);
        setSelectedIndex(0);
      } else if (e.key === "Escape") {
        setShowSuggestions(false);
      } else if (e.key === " ") {
        // Space pressed while suggestions open:
        // - For hashtag: commit manual typed hashtag (SearchText) as mention
        // - For mention: just close suggestions
        // if (mentionType === "Hashtag") {
        //   e.preventDefault();
        //   if (SearchText && SearchText.trim()) {
        //     insertMention(SearchText.trim(), null);
        //   }
        // }
        if (mentionType === "Hashtag") {
            if (SearchText && SearchText.trim()) {
              e.preventDefault();
              insertMention(SearchText.trim(), null, "Hashtag");
            }
          }

        setShowSuggestions(false);
        setSelectedIndex(0);
      }
    } else {
      if (e.key === " ") {
        setShowSuggestions(false);
        setSelectedIndex(0);
      }
    }
  };

   useEffect(() => {
      if (itemRefs.current[selectedIndex]) {
        itemRefs.current[selectedIndex].scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    }, [selectedIndex]);
  
    useEffect(() => {
      if (itemRefs.current[selectedIndex]) {
        itemRefs.current[selectedIndex].scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    }, [selectedIndex]);
  
    useEffect(() => {
      itemRefs.current = [];
      setSelectedIndex(0);
    }, [suggestions]);
  
    useEffect(() => {
      if (!showSuggestions) {
        setSelectedIndex(0);
      }
    }, [showSuggestions]);
  

  const prepareDynamicValuesForPayload = (dyn = []) => {
    return (dyn || []).map((d, idx) => ({
      type: d.type,
      dVno: d.dVno ?? idx + 1,
      entity: d.entity ?? d.entityID ?? d.userUid ?? "",
      displayName: d.displayName ?? d.display ?? "",
    }));
  };

  const updateSharedPost = async () => {
    setIsloading(true);
    try {
      setDisplay(true);
      const payload = {
        DeviceType: "Web",
        sessionId: sessionId,
        postId: postId,
        originPostId: userUid,
        PrivacyType: privacyType || "Public",
        // PostContent: editorContent,
        PostContent: postInputValue,
        // DynamicValues: postDynamicValues,
        DynamicValues: prepareDynamicValuesForPayload(postDynamicValues),
        langKey: language === "en" ? "" : language,

      };
      const res = await axios.post("/Posts/UpdateSharedPost", payload, {

        headers: {
          "Content-Type": "application/json",
        },
      });
      setToastMessage(res?.data?.message);
      setShowSuceessToast(true);
      // closeModal();
      setTimeout(() => {
        closeModal();
      }, 1000);
      // const newPostId = res?.data?.responseData?.id;
      const postDetailsResponse = await axios.get(
        `/Posts/GetPostInfo?DeviceType=Web&PostId=${postId}&RestrictedViewerToken=${restrictedViewerToken}&langKey=${language}`
      );
      const newPost = postDetailsResponse?.data?.responseData.postInfo;

      setPostList((prev) =>
        prev.map((post) =>
          post.postInfo.postId === postId
            ? normalizeNewsFeedPost(newPost, post.__sortTypePhase)
            : post
        )
      );
      // setPostList((prev) =>
      //     prev.map((post) =>
      //       post.postInfo.postId === postId
      //         ? {
      //             ...post,
      //             postInfo: newPost.postInfo,
      //             likes: post.likes,  // keep old
      //             comments: post.comments,  // keep old
      //             shares: post.shares,  // keep old
      //           }
      //         : post
      //     )
      //   );


      // setPostList((prevPosts) =>
      //   prevPosts.map((post) => {
      //     if (post.postInfo.postId === postId) {
      //       return {
      //         ...post,
      //         postInfo: {
      //           ...post.postInfo,
      //           postContent: postInputValue || sharedPostContent,
      //           dynamicValues: postDynamicValues,

      //         },
      //       };
      //     }
      //     return post;
      //   })
      // );

      // AllPostList();
      setPostDynamicValues([]);
      setPostInputValue("");
      setPostContent("");
      setPostID("");
      setIsloading(false);
      // setPostInputValue("");
    } catch (error) {
      console.log("newPostId", error);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
      setIsloading(false);
    }
  };

  const mainVideoRef = useRef(null);
  const sharedVideoRef = useRef(null);


  useEffect(() => {
    if (!openModal) return;

    const waitForRef = () => {
      const currentVideoRef = mainVideoRef.current;

      if (!currentVideoRef) {
        requestAnimationFrame(waitForRef);
        return;
      }

      const videoId = item?.postInfo?.mediaFilesList?.[0]?.mediaInfo;
      const manifestUrl = buildVideoIndexerManifestUrl({ videoId: videoId, accessToken: restrictedViewerToken });

      const hls = new Hls();
      hls.loadSource(manifestUrl);
      hls.attachMedia(currentVideoRef);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        const plyrInstance = new Plyr(currentVideoRef, {
          captions: { active: true, update: true, language: "en" },
        });
        currentVideoRef.muted = true; // always start muted
        currentVideoRef.play().catch(err => console.warn("Play failed", err));
      });
    };

    waitForRef();

  }, [openModal, item, restrictedViewerToken]);

  useEffect(() => {

    if (openModal && item?.postInfo?.sharedPost?.mediaFilesList?.[0]?.mediaType === "Video") {
      const videoId = item?.postInfo?.sharedPost?.mediaFilesList?.[0]?.mediaInfo;
      // const accountId = "3933d146-5f68-41d4-93a3-d2f7454d4a8d";
      const region = "centralindia";
      const currentVideoRef = sharedVideoRef.current;

      console.log("Shared videoId:", videoId);

      if (!videoId || !restrictedViewerToken || !currentVideoRef) {
        console.error("Missing shared videoId or token or ref.");
        return;
      }

      const manifestUrl = buildVideoIndexerManifestUrl({ videoId: videoId, accessToken: restrictedViewerToken, region: region });
      console.log("Shared manifestUrl:", manifestUrl);

      let hls;
      let plyrInstance;

      if (Hls.isSupported()) {
        hls = new Hls();
        hls.loadSource(manifestUrl);
        hls.attachMedia(currentVideoRef);

        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          console.log("✅ Shared Manifest parsed");
          plyrInstance = new Plyr(currentVideoRef, {
            captions: { active: true, update: true, language: "en" },
          });
          currentVideoRef?.play().catch(err => {
            console.warn("Shared video play interrupted", err);
          });
        });

        hls.on(Hls.Events.ERROR, (event, data) => {
          console.error("HLS.js Shared Video Error:", data);
        });
      } else if (currentVideoRef.canPlayType("application/vnd.apple.mpegurl")) {
        console.log(" Native HLS fallback for shared video");
        currentVideoRef.src = manifestUrl;
        currentVideoRef.addEventListener("loadedmetadata", () => {
          currentVideoRef?.play();
        });
      }

      return () => {
        if (plyrInstance) plyrInstance.destroy();
        if (hls) hls.destroy();
      };
    }
  }, [item, restrictedViewerToken]);

  console.log("item?.postInfo?.sharedPost", item?.postInfo);

  const handlePostUpdateEscapeClose = useCallback(() => {
    if (showSuggestions) {
      setShowSuggestions(false);
      return;
    }
    closeModal();
  }, [showSuggestions, closeModal]);

  useEscapeKeyDown(!!showModal, handlePostUpdateEscapeClose);

  return (
    <>
      {openModal && (
        <Portal layer="modal">
        {item?.postInfo?.sharedPost ? (
          <div className="m-3">
            <div
              className="modal fade show postAdd wlj-overlay-modal"
              tabIndex="-1"
              role="dialog"
              style={{ display: "flex" }}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content p-2">
                  <div className="modalBorder d-flex justify-content-between align-items-center">
                    <h6>{t("Newsfeed.Update Shared Post")}</h6>
                    <CloseSharpIcon
                      className="material-symbols-sharp me-2 pointer"
                      onClick={closeModal}
                    />
                  </div>

                  <div className="m-3">

                    <div className="d-flex align-items-center mt-4">
                      <div className="ImgAvatar">
                        <img
                          src={item?.postInfo?.userAvatar}
                          alt=""
                          style={{ borderRadius: "50px" }}
                        />
                      </div>

                      <div className="ms-2">
                        <h4 className="f-14 fw-bold mb-0">
                          {item?.postInfo?.userName}{" "}
                        </h4>
                        <p className="f-12">{item?.postInfo?.title}</p>
                        <p className="f-12">{item?.postInfo?.additionalInfo}</p>
                        <p className="f-10 label">
                          {moment
                            .utc(item?.postInfo?.creationTime)
                            .local()
                            .format("DD MMMM YYYY [at] h:mm a")}
                        </p>
                      </div>
                    </div> 
                    <div> 
                      {sharedPostContent !== null && (
                        <div className="f-14 p-2 postContent">
                
                          <ReactQuill
                            ref={editorRef}
                            value={postContent}
                            onChange={handleChange} 
                            onKeyDown={handleKeyDown1}
                            placeholder={t("Drafts.Update Post")}
                            
                            modules={{
                              toolbar: false,
                            }}
                            formats={[
                              "header",
                              "font",
                              "size",
                              "bold",
                              "italic",
                              "underline",
                              "strike",
                              "blockquote",
                              "list",
                              "bullet",
                              "indent",
                              "link",
                            ]}
                            />
                            {showSuggestions && (
                              <ul className="suggestion-box">
                                {mentionType === "Hashtag" ? <li
                                  onMouseDown={(e) => {
                                    e.preventDefault(); // Prevent editor blur
                                    insertMention(
                                      SearchText,
                                      null
                                    );
                                  }}
                                  className="suggestion-item"
                                >
                                  <span>{SearchText ? `#${SearchText}` : ''}</span>
                                </li> : null}
                                {suggestions?.map((item, index) => (
                                  <li
                                    key={index}
                                    onMouseDown={(e) => {
                                      e.preventDefault(); // Prevent editor blur
                                      e.stopPropagation();
                                      insertMention(
                                        mentionType === "UserMention"
                                          ? item?.entityName
                                          : item?.hashTag,
                                        mentionType === "UserMention"
                                          ? item?.userUid
                                          : null,
                                        item.entityType
                                      );
                                    }}
                                    className="suggestion-item"
                                  >
                                    {mentionType === "UserMention" ? (
                                      <>
                                        <img
                                          src={item?.avatar}
                                          alt={item?.entityName}
                                          className="avatar"
                                        />
                                        <span>{item?.entityName}</span>
                                      </>
                                    ) : (
                                      <span>#{item?.hashTag}</span>
                                    )}
                                  </li>
                                ))}
                              </ul>
                            )}
                        </div>
                      )}

                      {item?.postInfo ? (
                        <>
                          <div className="row w-94 m-0 singlePostLink">
                            <div className="featured-card user-postOnlyContent">
                              <div className="feature-content p-2 d-flex justify-content-between">
                                {item?.postInfo?.postOriginType ===
                                  "Company" ? (
                                  <Link
                                    to={`/Company/${item?.postInfo?.userUid}`}
                                  >
                                    <div className="d-flex align-items-center">
                                      <div className="ImgAvatar">
                                        <img
                                          src={
                                            item?.postInfo?.userAvatar
                                          }
                                          alt=""
                                          style={{ borderRadius: "50px" }}
                                        />
                                      </div>
                                      <div className="ms-2">
                                        <h4 className="f-14 fw-bold mb-0">
                                          {item?.postInfo?.userName}
                                        </h4>
                                        <p className="f-12">
                                          {/* {moment(item?.sharedPost.creationTime).format(
                                                        "MMMM Do YYYY, h:mm:ss a"
                                                      )} */}
                                          {moment
                                            .utc(
                                              item?.postInfo
                                                ?.creationTime
                                            )
                                            .local()
                                            .format(
                                              "DD MMMM YYYY [at] h:mm a"
                                            )}
                                        </p>
                                      </div>
                                    </div>
                                  </Link>
                                ) : (
                                  <Link
                                    to={`/User/${item?.postInfo?.userUid}`}
                                  >
                                    <div className="d-flex align-items-center">
                                      <div className="ImgAvatar">
                                        <img
                                          src={
                                            item?.postInfo?.userAvatar
                                          }
                                          alt=""
                                          style={{ borderRadius: "50px" }}
                                        />
                                      </div>
                                      <div className="ms-2">
                                        <h4 className="f-14 fw-bold mb-0">
                                          {item?.postInfo?.userName}
                                        </h4>
                                        <p className="f-12">
                                          {/* {moment(item?.sharedPost.creationTime).format(
                                                        "MMMM Do YYYY, h:mm:ss a"
                                                      )} */}
                                          {moment
                                            .utc(
                                              item?.postInfo
                                                ?.creationTime
                                            )
                                            .local()
                                            .format(
                                              "DD MMMM YYYY [at] h:mm a"
                                            )}
                                        </p>
                                      </div>
                                    </div>
                                  </Link>
                                )}

                                {/* {guestModeData === "true" ? null : (
                                        <div className="row">
                                          <div>
                                            <SinglePostInteraction
                                              postId={item?.postInfo?.postId}
                                            // AllPostList={AllPostList}
                                            // ite.sharedPost={item?.sharedPost}
                                            // setitem?.sharedPost={setitem?.sharedPost}
                                            // isfollowed={isfollowed}
                                            // setIsfollowed={setIsfollowed}
                                            />
                                          </div>
                                        </div>
                                      )} */}
                              </div>

                              {item?.postInfo?.sharedPost && (
                                <>
                                  <div className="f-14 p-2 postContent">
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          sharedPostFormattedContent1,
                                      }}
                                    />
                                  </div>
                                  <div
                                    className="feed-post"
                                    style={{
                                      paddingTop:
                                        item?.postInfo?.sharedPost?.postMediaCount === 0
                                          ? "60px"
                                          : "4px",
                                    }}
                                  >
                                    <div className="row">
                                      {item?.postInfo?.sharedPost?.mediaFilesList
                                        ?.slice(0, 4)
                                        ?.map((file, idx) => (
                                          <div
                                            key={idx}
                                            className={`col-${item?.postInfo?.sharedPost
                                              ?.mediaFilesList
                                              .length === 1
                                              ? "12"
                                              : "6"
                                              } ${item?.postInfo
                                                ?.sharedPost?.mediaFilesList
                                                .length === 3 && idx === 0
                                                ? "col-12"
                                                : ""
                                              }`}
                                            style={{
                                              position: "relative",
                                              padding:
                                                item?.postInfo
                                                  ?.sharedPost?.mediaFilesList
                                                  .length === 1
                                                  ? "0"
                                                  : item?.postInfo
                                                    ?.sharedPost?.mediaFilesList
                                                    .length === 3 &&
                                                    idx === 0
                                                    ? "0 0 5px 0"
                                                    : item?.postInfo
                                                      ?.sharedPost?.mediaFilesList
                                                      .length === 3 &&
                                                      idx === 1
                                                      ? "0 5px 5px 0"
                                                      : item?.postInfo
                                                        ?.sharedPost?.mediaFilesList
                                                        .length === 4 &&
                                                        idx === 2
                                                        ? "0 5px 0 0"
                                                        : item?.postInfo
                                                          ?.sharedPost?.mediaFilesList
                                                          .length === 4 &&
                                                          idx === 0
                                                          ? "0 5px 5px 0"
                                                          : item?.postInfo
                                                            ?.sharedPost?.mediaFilesList
                                                            .length === 2 &&
                                                            idx === 0
                                                            ? "0 5px 5px 0"
                                                            : "0",
                                            }}
                                          >
                                            <h2>{file.length}</h2>
                                            {/* <img
                                                    src={file.mediaName}
                                                    alt=""
                                                    className="img-fluid"
                                                    width={"100%"}
                                                  /> */}
                                            {file.mediaType === "Image" ? (
                                              <ImageWithLoader
                                                src={`${file.mediaName}`}
                                                alt=""
                                                className="img-fluid"
                                                width="100%"
                                                style={{ maxHeight: "300px" }}
                                                minHeight={220}
                                              />
                                            ) : (
                                              // <video
                                              //   controls
                                              //   src={file.mediaName}
                                              //   className="img-fluid"
                                              //   width="100%"
                                              // />
                                              // <iframe
                                              //   style={{
                                              //     marginTop: '-1px',
                                              //   }}
                                              //   width="100%"
                                              //   height="300"
                                              //   src={`https://www.videoindexer.ai/embed/player/3933d146-5f68-41d4-93a3-d2f7454d4a8d/${file?.mediaInfo}/?accessToken=${postDataItem.restrictedViewerToken}&location=centralindia&controls=true&autoplay=true`}
                                              //   frameBorder="0"
                                              //   allow="autoplay"
                                              //   allowFullScreen
                                              // />
                                              <video
                                                ref={sharedVideoRef}
                                                controls
                                                autoPlay={false}
                                                muted
                                                width="100%"
                                                height="300"
                                                playsInline
                                                className="video-js"
                                                style={{ backgroundColor: "#000", maxHeight: "300px" }}
                                              />
                                            )}
                                            {idx === 3 &&
                                              item?.postInfo?.sharedPost
                                                ?.postMediaCount > 4 && (
                                                <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                                                  +
                                                  {item?.postInfo?.sharedPost
                                                    ?.postMediaCount - 4}
                                                </div>
                                              )}
                                          </div>
                                        ))}
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                          {/* </div> */}
                        </>
                      ) : (
                        ""
                      )}
                    </div>

                    {/* Main post image */}
                    <div
                      className="feed-post"
                      style={{
                        paddingTop:
                          item?.postInfo?.postMediaCount === 0 ? "60px" : "4px",
                      }}
                    >
                      <div className="row">
                        {item?.postInfo?.mediaFilesList
                          ?.slice(0, 4)
                          .map((file, idx) => (
                            <div
                              key={idx}
                              className={`col-${item?.postInfo?.mediaFilesList.length === 1
                                ? "12"
                                : "6"
                                } ${item?.postInfo?.mediaFilesList.length === 3 &&
                                  idx === 0
                                  ? "col-12"
                                  : ""
                                }`}
                              style={{
                                position: "relative",
                                padding:
                                  item?.postInfo?.mediaFilesList.length === 3 &&
                                    idx === 0
                                    ? "0 0 5px 0"
                                    : item?.postInfo?.mediaFilesList.length === 3 &&
                                      idx === 1
                                      ? "0 5px 5px 0"
                                      : item?.postInfo?.mediaFilesList.length === 4 &&
                                        idx === 2
                                        ? "0 5px 0 0"
                                        : item?.postInfo?.mediaFilesList.length === 4 &&
                                          idx === 0
                                          ? "0 5px 5px 0"
                                          : item?.postInfo?.mediaFilesList.length === 2 &&
                                            idx === 0
                                            ? "0 5px 5px 0"
                                            : "",
                              }}
                            >
                              <ImageWithLoader
                                src={file.mediaName}
                                alt=""
                                className="img-fluid"
                                width={"100%"}
                              />
                              {idx === 3 && item?.postInfo?.postMediaCount > 4 && (
                                <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                                  +{item?.postInfo?.postMediaCount - 4}
                                </div>
                              )}
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>

                  <div className="m-3 mb-1 d-flex align-items-center">
                    <button
                      className="mainBtn ms-auto"
                      disabled={isloading}
                      onClick={updateSharedPost}
                    >
                      {isloading === true ? `${t("User Profile.Updating")}` : `${t("Drafts.Update Post")}`}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>



        ) : (
          <Portal layer="modal">
          <div
            className="modal fade show postAdd wlj-overlay-modal"
            tabIndex="-1"
            role="dialog"
            style={{ display: "flex" }}
          >

            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content p-2">
                <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                  <h6>{item.cntntTypCategory === "TextWithVideo" ||
                    item.cntntTypCategory === "Video" ? `${t("Drafts.Update Video Post")}`: `${t("Drafts.Update Post")}` }</h6>
                  <Select
                    defaultValue={privacy.find(
                      (option) => option.value === privacyType
                    )}
                    onChange={(selectedOption) => {
                      setPrivacyType(selectedOption.value);
                    }}
                    options={privacy}
                    placeholder={t("Newsfeed.Select Privacy")}
                    styles={customStyles} {...wljSelectPortalProps}
                    formatOptionLabel={({ label, icon }) => (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {icon}
                        <span style={{ marginLeft: 8 }}>{label}</span>
                      </div>
                    )}
                  />
                  <CloseSharpIcon
                    className="material-symbols-sharp me-2 pointer"
                    onClick={closeModal}
                  />
                </div>
                {/* <div className="d-flex align-items-center m-3 pb-3 modalBorder ">
                <div className="ImgAvatar">
                  <img src={profilPic} alt="" width={50} style={{ borderRadius: '50%' }} />
                </div>
                <p className="f-16 AddPost ms-2">What's on your mind?</p>
              </div> */}
                <div className="m-3">
                  <ReactQuill
                    ref={editorRef}
                    value={postContent}
                    onChange={handleChange} 
                    onKeyDown={handleKeyDown1}
                    placeholder={t("Drafts.Update Post")}
                    
                    modules={{
                      toolbar: false,
                    }}
                    formats={[
                      "header",
                      "font",
                      "size",
                      "bold",
                      "italic",
                      "underline",
                      "strike",
                      "blockquote",
                      "list",
                      "bullet",
                      "indent",
                      "link",
                    ]}
                  />
                  {showSuggestions && (
                    <ul className="suggestion-box">
                      {mentionType === "Hashtag" ? <li
                        onMouseDown={(e) => {
                          e.preventDefault(); // Prevent editor blur
                          insertMention(
                            SearchText,
                            null
                          );
                        }}
                        className="suggestion-item"
                      >
                        <span>{SearchText ? `#${SearchText}` : ''}</span>
                      </li> : null}
                      {suggestions?.map((item, index) => (
                        <li
                          key={index}
                          onMouseDown={(e) => {
                            e.preventDefault(); // Prevent editor blur
                             e.stopPropagation();
                            insertMention(
                              mentionType === "UserMention"
                                ? item?.entityName
                                : item?.hashTag,
                              mentionType === "UserMention"
                                ? item?.userUid
                                : null,
                              item.entityType
                            );
                          }}
                          className="suggestion-item"
                        >
                          {mentionType === "UserMention" ? (
                            <>
                              <img
                                src={item?.avatar}
                                alt={item?.entityName}
                                className="avatar"
                              />
                              <span>{item?.entityName}</span>
                            </>
                          ) : (
                            <span>#{item?.hashTag}</span>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}


                  {/* Main post image */}
                  <div
                    className="feed-post"
                    style={{
                      paddingTop: item?.postInfo?.postMediaCount === 0 ? "60px" : "4px",
                    }}
                  >
                     
                    
                  </div>
                </div>

                {/* Adding Extra Image */}
                <div className="modal-border d-flex justify-content-center align-items-center">
                  <input
                    id="fileInput"
                    type="file"
                    onChange={(event) => {
                      imageSelect(event);
                    }}
                    style={{ display: "none" }}
                    ref={inputFileRef}
                    multiple
                  />

                  {images.length > 0 && (
                    <div className="post-selected d-flex justify-content-center flex-wrap">
                      {images.map((image, index) => (
                        <div key={index} className="position-relative m-2">
                          <img
                            src={image.url}
                            alt={`Selected Image ${index}`}
                            style={{
                              maxWidth: "200px",
                              maxHeight: "300px",
                              objectFit: "cover",
                            }}
                          />
                          <button
                            onClick={() => removeImage(index)}
                            className="btn btn-danger position-absolute top-0 end-0"
                            style={{
                              transform: "translate(50%, -50%)",
                              borderRadius: "50%",
                              width: "24px",
                              height: "24px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "0",
                            }}
                          >
                            &times;
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* {userSelectedImage?.length > 0 && (
                  <div className="post-selected hhh d-flex justify-content-center flex-wrap">
                    {userSelectedImage?.map((imageUrl, index) => (
                      <div key={index} className="position-relative m-2">
                        <img
                          src={imageUrl.mediaName}
                          alt={`Selected Image ${index}`}
                          style={{
                            maxWidth: "200px",
                            maxHeight: "300px",
                            objectFit: "cover",
                          }}
                        />
                        <button
                          onClick={() => userImages(index)}
                          className="btn btn-danger position-absolute top-0 end-0"
                          style={{
                            transform: "translate(50%, -50%)",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "0",
                          }}
                        >
                          &times;
                        </button>
                      </div>
                    ))}
                  </div>
                )} */}
                {userSelectedImage?.length > 0 && (
                  <div className="post-selected hhh d-flex justify-content-center flex-wrap">
                    {userSelectedImage?.map((media, index) => (
                      <div key={index} className="position-relative m-2 col-12 text-center"  >
                        {media.mediaType === "Image" ? (
                          <>
                            <div key={index} className="position-relative m-2">
                              <ImageWithLoader
                                src={media.mediaName}
                                alt={`Selected Image ${index}`}
                                style={{
                                  maxWidth: "200px",
                                  maxHeight: "300px",
                                  objectFit: "cover",
                                }}
                                minHeight={160}
                                wrapperClassName="img-with-loader--sm"
                              />
                              <button
                                onClick={() => userImages(index)}
                                className="btn btn-danger position-absolute top-0 end-0"
                                style={{
                                  transform: "translate(-500%, -50%)",
                                  borderRadius: "50%",
                                  width: "24px",
                                  height: "24px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  padding: "0",
                                }}
                              >
                                &times;
                              </button>
                            </div>
                          </>

                        ) : (
                          // <video
                          //   src={media.mediaName}
                          //   controls
                          //   style={{
                          //     maxWidth: "200px",
                          //     maxHeight: "300px",
                          //     objectFit: "cover",
                          //   }}
                          ///>
                          <div style={{ width: '100%', maxWidth: '700px' }}>
                            {/* <iframe
                              style={{
                                width: '100%',
                                height: '300px',
                                marginTop: '-2px',
                              }}
                              src={`https://www.videoindexer.ai/embed/player/3933d146-5f68-41d4-93a3-d2f7454d4a8d/${media?.mediaInfo}/?accessToken=${postDataItem.restrictedViewerToken}&location=centralindia&controls=true&autoplay=true`}
                              frameBorder="0"
                              allow="autoplay"
                              allowFullScreen
                            /> */}
                            <video
                              ref={mainVideoRef}
                              controls
                              autoPlay={false}
                              muted
                              width="100%"
                              height="300"
                              playsInline
                              className="video-js"
                              style={{ backgroundColor: "#000", maxHeight: "300px" }}
                            />
                          </div>
                        )}
                        {/* <button
                          onClick={() => userImages(index)}
                          className="btn btn-danger position-absolute top-0 end-0"
                          style={{
                            transform: "translate(50%, -50%)",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "0",
                          }}
                        > 
                          &times;
                        </button>*/}
                      </div>
                    ))}
                  </div>
                )}

                <div className="m-3 mb-1 d-flex align-items-center">
                  <form className="form" action="#" method="post" id="form">
                    <input
                      type="file"
                      name="Image"
                      id="image"
                      multiple
                      className="d-none"
                      onChange={(event) => {
                        imageSelect(event);
                      }}
                      ref={inputFileRef}
                    />
                    <AddAPhotoSharpIcon
                      className="material-symbols-sharp me-2 mt-2 pointer"
                      onClick={() => inputFileRef.current.click()} // Trigger the file input click
                    />
                  </form>
                  <button
                    className="mainBtn ms-auto"
                    disabled={isloading}
                    onClick={handleSubmit}
                  >
                    {isloading === true ? `${t("User Profile.Updating")}` : `${t("Drafts.Update Post")}`}
                  </button>
                </div>
              </div>
            </div>
          </div>
          </Portal>

        )}
        </Portal>
      )}

      <SuccessToast
        show={showsuccessToast}
        message={toastMessage}
        onClose={() => setShowSuceessToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default PostUpdate;
